// Sourced from @retracedgmbh/modules so the frontend dropzone and the backend
// upload allow-list share a single source of truth.
import { EXTENSION_TO_MIME } from '@retracedgmbh/modules';

export { EXTENSION_TO_MIME };

export function extensionsToMimeRecord(
  extensions: string[],
): Record<string, string[]> {
  const mimeTypes: Record<string, string[]> = {};
  for (const ext of extensions) {
    const mime = EXTENSION_TO_MIME[ext.toLowerCase()];
    if (mime) {
      if (!mimeTypes[mime]) mimeTypes[mime] = [];
      mimeTypes[mime].push(ext);
    }
  }
  return mimeTypes;
}

export function normalizeAcceptedFileTypes(
  input?: string[] | Record<string, string[]>,
): Record<string, string[]> {
  if (!input) return {};
  if (Array.isArray(input)) return extensionsToMimeRecord(input);
  return input;
}
